import { FC, useState } from "react";
import colors from "../config/Colors.config";
import { Col, Label, Row } from "reactstrap";
import Block from "../components/Block.component";
import Device from "../interfaces/Device.interface";
import DeviceConfig from "../config/Device.config";
import Usuario from "../interfaces/Usuario.interface";

import imgWork from "../assets/svg/work.svg";

const HomeView: FC<{ usuario: Usuario }> = ({ usuario }) => {

    const [personnel] = useState<Usuario>(usuario);
    const [data] = useState<Device>(DeviceConfig.data());

    return (
        <section style={{ minHeight: "100vh", height: "100vh", maxHeight: "auto", marginLeft: 0, backgroundColor: colors.blanco }} >
            <Block height={"10vh"} />
            <Row style={{ marginRight: 0, marginLeft: 0 }} >
                <Col style={{ textAlign: "center" }} >

                    {
                        data.isDesktop ?
                            <img src={imgWork} height={data.isDesktop ? 300 : 150} style={{ marginLeft: data.isDesktop ? 155 : 0, marginRight: 150 }} alt="No se pudo cargar la imagen" />
                            :
                            <center>
                                <img src={imgWork} style={{ height: 150 }} alt="No se pudo cargar la imagen" />
                            </center>
                    }

                </Col>
            </Row>
            <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                <Col style={{ textAlign: "center" }} >
                    <Label style={{ fontSize: data.isDesktop ? 52 : 32, fontWeight: "bold", color: colors.secundario }} >
                        OPERADORA TZEDAKÁ, S.A.P.I. DE C.V.
                    </Label>
                </Col>
            </Row>
            <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                <Col style={{ textAlign: "center" }} >
                    <Label style={{ fontSize: data.isDesktop ? 36 : 28, fontWeight: "bold", color: colors.secundario }} >
                        CRÉDITOS AL ALCANCE DE TODOS
                    </Label>
                </Col>
            </Row>
            <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                <Col style={{ textAlign: "center" }} >
                    <Label style={{ fontSize: data.isDesktop ? 26 : 18, fontWeight: "bold", color: colors.secundario }} >
                        Bienvenido {personnel.nombreCompleto}
                    </Label>
                </Col>
            </Row>
        </section>
    )
}

export default HomeView;